import { render, staticRenderFns } from "./DialogSignUpSelection.vue?vue&type=template&id=898d565c&scoped=true&"
import script from "./DialogSignUpSelection.vue?vue&type=script&lang=js&"
export * from "./DialogSignUpSelection.vue?vue&type=script&lang=js&"
import style0 from "./DialogSignUpSelection.vue?vue&type=style&index=0&id=898d565c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d565c",
  null
  
)

export default component.exports